import(/* webpackMode: "eager", webpackExports: ["Wizard"] */ "/app/apps/copilot/components/sections/wizard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebchatButton"] */ "/app/apps/copilot/components/webchat-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/script.js");
